
import React from 'react'
import DashBody from '../../Layout/Dashboard/DashBody'
import DashHeader from '../../Layout/Dashboard/DashHeader'
import LyTable from '../../Layout/Dashboard/LyTable'
import useTableColumns from './useTableColumns'
import { useGetStaticInfo} from '../../api/StaticInfo'
import { QueryStatusEnum } from '../../config/QueryStatus'
import EditStaticInfoModal from './EditStaticInfoModal'
import AddStaticInfoModal from './AddStaticInfoModal'

function StaticInfoPage() {

    const column   =useTableColumns()
    const {data  ,status } = useGetStaticInfo()

    
  return (
    // Pass Status to Layout 
    <DashBody  status={status as QueryStatusEnum} >
      <DashHeader showAddButton={false} title={'StaticInfo'}></DashHeader>
      
      <LyTable
        data={data}
        isLoading={false}
        columns={column}
      />
      
      <EditStaticInfoModal />
      <AddStaticInfoModal />
      
    </DashBody>
  )
}

export default StaticInfoPage

